import { createSlice } from "@reduxjs/toolkit";

const initialData = {
  windowsErrorList: null,
  modifiedWindowsList: null,
  failedWindowsList: null,
  formTrigger: null,
};

const slice = createSlice({
  name: "modifiedWindows",
  initialState: initialData,
  reducers: {
    updateWindowErrors: (state, action) => {
      if (action.payload.errors) {
        const obj = state.windowsErrorList || {};
        obj[action.payload.windowName] = action.payload;
        state.windowsErrorList = obj;
      } else {
        const obj = state.windowsErrorList || {};
        delete obj[action.payload.windowName];
        state.windowsErrorList = obj;
      }

      if (action.payload.trigger) {
        state.formTrigger = action.payload.trigger;
      }
    },
    updateFailedWIndowsList: (state, action) => {
      if (action.payload.window) {
        const obj = state.failedWindowsList || {};
        obj[action.payload.window] = action.payload.error;
        state.failedWindowsList = obj;
      }
    },
    updateModifiedWindows: (state, action) => {
      const obj = state.modifiedWindowsList || {};
      obj[action.payload.windowName] = action.payload;
      state.modifiedWindowsList = obj;
    },
    reverseToInitValue: (state, action) => {
      if (
        state?.modifiedWindowsList?.[action.payload.window] &&
        state.modifiedWindowsList?.[action.payload.window]?.["data"]?.[action.payload.formKey]
      ) {
        state.modifiedWindowsList[action.payload.window]["data"][action.payload.formKey] =
          action.payload.oldValue;
      }
    },
    removeModifiedWindow: (state, action) => {
      const obj = state.modifiedWindowsList || {};
      delete obj[action.payload.windowName];
      const obj2 = state.windowsErrorList || {};
      delete obj2[action.payload.windowName];
      state.modifiedWindowsList = obj;
      state.windowsErrorList = obj2;
    },
    clearAllModifiedWindow: (state, action) => {
      state.modifiedWindowsList = {};
      state.windowsErrorList = {};
      state.failedWindowsList = {};
    },
    clearWindowError: (state, action) => {
      if (action.payload.window) {
        const obj = state.failedWindowsList || {};
        delete obj[action.payload.window];
        state.failedWindowsList = obj;
      }
    },
    handleResetButton: (state, action) => {
      const obj = state.modifiedWindowsList || {};
      delete obj[action.payload.windowName];
      const obj2 = state.windowsErrorList || {};
      delete obj2[action.payload.windowName];
      state.modifiedWindowsList = obj;
      state.windowsErrorList = obj2;
      if (action.payload.windowName) {
        const obj = state.failedWindowsList || {};
        delete obj[action.payload.windowName];
        state.failedWindowsList = obj;
      }
      deleteModifiedWindowSessionItem(action?.payload?.windowName);
    },
  },
});
export const {
  updateWindowErrors,
  updateModifiedWindows,
  removeModifiedWindow,
  updateFailedWIndowsList,
  clearWindowError,
  clearAllModifiedWindow,
  handleResetButton,
  reverseToInitValue,
} = slice.actions;

export default slice.reducer;

export function deleteModifiedWindowSessionItem(window, field) {
  let sessionData = sessionStorage.getItem("modifiedWindowsFields") || JSON.stringify({});
  try {
    sessionData = JSON.parse(sessionData);
  } catch (err) {
    sessionData = {};
  }
  if (field) {
    delete sessionData[window][field];
  } else {
    delete sessionData[window];
  }
  if (sessionData?.[window] && Object.keys(sessionData[window]).length === 0) {
    delete sessionData[window];
  }
  sessionStorage.setItem("modifiedWindowsFields", JSON.stringify(sessionData));
}
